(function () {
  function parseDate(value) {
    if (!value) return null;
    var parts = value.trim().split(/[\s/:-]+/).map(Number);
    if (parts.length < 3 || parts.some(Number.isNaN)) return null;
    return new Date(parts[0], parts[1] - 1, parts[2], parts[3] || 0, parts[4] || 0, parts[5] || 0);
  }

  function startCountdown(element) {
    var target = parseDate(element.dataset.countdownDate);
    if (!target) return;
    var loopDays = Number(element.dataset.countdownLoop || 0);
    var dayLabel = element.dataset.countdownDayLabel || 'days';
    function update() {
      var now = new Date();
      var end = target;
      if (loopDays > 0) {
        var period = loopDays * 86400000;
        end = new Date(target.getTime() + Math.ceil((now - target) / period) * period);
      }
      var remaining = end - now;
      if (remaining < 0) {
        element.textContent = '0 ' + dayLabel + ' 00:00:00';
        return;
      }
      var seconds = Math.floor(remaining / 1000);
      var days = Math.floor(seconds / 86400);
      seconds %= 86400;
      var hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
      seconds %= 3600;
      var minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
      seconds = String(seconds % 60).padStart(2, '0');
      element.textContent = days + ' ' + dayLabel + ' ' + hours + ':' + minutes + ':' + seconds;
    }
    update();
    window.setInterval(update, 1000);
  }

  function init(root) {
    if (root.dataset.doyoAnnouncementInitialized) return;
    root.dataset.doyoAnnouncementInitialized = 'true';
    root.querySelectorAll('[data-countdown-date]').forEach(startCountdown);
    var items = Array.from(root.querySelectorAll('[data-doyo-announcement-item]'));
    var track = root.querySelector('[data-doyo-announcement-track]');
    var effect = root.classList.contains('doyo-announcement-bar--effect-1') ? 'fade' : 'slide';
    var index = 0;
    var timer;
    function show(next) {
      if (items.length < 2) return;
      if (effect === 'fade') {
        root.classList.add('doyo-announcement-bar--is-fading');
        window.setTimeout(function () {
          items.forEach(function (item, itemIndex) { item.style.display = itemIndex === next ? 'flex' : 'none'; });
          root.classList.remove('doyo-announcement-bar--is-fading');
        }, 250);
      } else {
        track.style.transform = 'translateX(-' + next * 100 + '%)';
      }
      index = next;
    }
    function schedule() {
      var interval = Number(root.dataset.autoPlay || 0);
      if (interval > 0 && items.length > 1) timer = window.setInterval(function () { show((index + 1) % items.length); }, interval);
    }
    root.addEventListener('mouseenter', function () { if (timer) window.clearInterval(timer); });
    root.addEventListener('mouseleave', schedule);
    root.querySelector('[data-doyo-announcement-close]')?.addEventListener('click', function () {
      var key = root.dataset.cookieKey;
      var days = Number(root.dataset.cookieDays || 0);
      document.cookie = key + '=closed; path=/; max-age=' + (days > 0 ? days * 86400 : 31536000);
      root.hidden = true;
    });
    if (document.cookie.indexOf(root.dataset.cookieKey + '=closed') !== -1 && !window.Shopify?.designMode) root.hidden = true;
    schedule();
  }

  function initAll() { document.querySelectorAll('[data-doyo-announcement-bar]').forEach(init); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll?.('[data-doyo-announcement-bar]').forEach(init); });
})();
